export const ENV = "dev";

export const API_HOST = "https://proxy.dev.api.letsplaymusicsite.com/v2";
export const API_NAME = "dev-api";
export const API_CONFIG = { endpoints: [{ name: API_NAME, endpoint: API_HOST }] };

export const COGNITO_CONFIG = {
  region: "us-east-1",
  userPoolId: "us-east-1_Agj9H4jYz",
  userPoolWebClientId: "pp84qb58mt9pt60rq9pdl24r1",
  authenticationFlowType: "USER_PASSWORD_AUTH"
};

export const GOOGLE_MAPS_API_KEY = "AIzaSyAz3k2hxd9o-1xBuAccq8_GeU5JDoaVncQ";
export const MAZAMA_FACEBOOK_PIXEL_ID = "801152897229088";